import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="px-4 pb-4">
      <div className="max-w-[1400px] mx-auto bg-foreground-900 rounded-[32px] px-8 md:px-16 py-14 md:py-20 overflow-hidden relative">
        {/* Background brand text */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none opacity-[0.04]">
          <span className="font-heading text-[180px] md:text-[280px] font-bold text-background-50 whitespace-nowrap">
            KAKOBUYFINDS
          </span>
        </div>

        <div className="relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
            {/* Brand column */}
            <div className="md:col-span-4">
              <h3 className="font-heading text-3xl md:text-4xl font-bold text-background-50 leading-tight">
                Find Everything.
              </h3>
              <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-xs">
                Your ultimate resource for shopping spreadsheets, product finds, and category guides. Updated regularly with fresh discoveries.
              </p>
            </div>

            {/* Quick Links */}
            <div className="md:col-span-2">
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">Home</Link>
                <Link to="/article/kakobuy-spreadsheet-complete-guide" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">Complete Guide</Link>
                <Link to="/article/kakobuy-spreadsheet-vs-cssbuy-superbuy" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">Platform Comparison</Link>
                <Link to="/article/kakobuy-spreadsheet-for-beginners" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">Beginner Guide</Link>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">Kakobuy Sheet</a>
              </div>
            </div>

            {/* Categories */}
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Top Categories</h4>
              <div className="grid grid-cols-2 gap-2.5">
                {categories.slice(0, 8).map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors truncate"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Resources */}
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/article/kakobuy-spreadsheet-complete-guide" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  <i className="ri-article-line mr-2"></i>Spreadsheet Guides
                </Link>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  <i className="ri-shopping-bag-3-line mr-2"></i>Shop Products
                </a>
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  <i className="ri-home-4-line mr-2"></i>Homepage
                </Link>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} KakobuyFinds. All rights reserved.
            </p>
            <p className="text-xs text-foreground-400">
              Built for smart shoppers &bull; Updated daily
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}